// extracted by mini-css-extract-plugin
module.exports = {"Violet_Border_Button":"Violet_Border_Button_Violet_Border_Button__3faY9","button_text":"Violet_Border_Button_button_text__lcMMc"};